import React, { useContext } from 'react'
import styled from "styled-components";
import { DilContext } from '../ContextDil';


const Title = styled.div`
  width: 100%;
  display: flex;
  
  flex:0;
  
  justify-content: space-between;
  padding: 0.7rem 0.1rem;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
`;
const TopTitle = styled.div`
  width: 100%;
  display: flex;
  padding: 0.5rem;
  font-size: 1.5rem;
  font-weight: bold;
  /* background-color: bisque; */

  
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
`;

const TitleRight = styled.span`
  display: flex;
  flex-direction: column;
  width:20%;
  align-items: flex-end;
  text-align: right;
  font-size: 0.7rem;
 
  line-height: 1;
  color: red;
`;
const Check = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1rem;
 
  width:80%;
  line-height: 1;
  margin: 0.1rem;
  /* input[type=checkbox] {
	position: absolute;
   	left: -9999px;
   	
    &+label {
    	cursor: pointer;
    	display: inline-block;
    	margin: 5px !important;
    	position: relative;

    	// Border box
    	&:before {   	
    		background-color: white;
    		border: 2px solid gray;
    		border-radius: 3px;
    		content: "";
    		display: inline-block;
    		height: 16px;
    		margin-right: 8px;
    		position: relative;
    		top: 3px;
    		width: 16px;
    	}
    }

    // Checked state
    &:checked {
    	&+label {
    		// Border box
    		&:before {
    			// Checked state border and fill can be set here
    			// background-color: blue;
    		}    	

    		// Draw checkmark
	    	&:after {	
			    content: '';
			    display: inline-block;
			 
			    // Set size of our bounding box for the check shape
			    width: 5px;
			    height: 11px;
			 
			    // Add a dark border on the bottom and left, creating an 'L' shape
			    border: solid black;
			    border-width: 0 2px 2px 0;
			 
			    // Rotate the L 45 degrees to turn it into a checkmark
			    transform: rotate(45deg);

			    // Then position the checkmark within the border box
			    position: absolute;
			    top: 4px;
			    left: 6px;
	    	}
    	}
    }
} */
`;

const DetayLineNot = ({ack,data}) => {
   
  const {lang} =useContext(DilContext);
      
    return (
       <>
      
       <TopTitle>{ack}</TopTitle>
         {data && data.map((res, index) => (
             <Title key={index}>
            <Check>
            {res.DESCRIPTION}
                {/* <input id={res.ACIKLAMA} name="check" type="checkbox"/>
                <label for={res.ACIKLAMA}>{res.ACIKLAMA}</label> */}
            </Check>
            <TitleRight></TitleRight>
            </Title>
             ))}
           
       </>
      
    )
}

export default DetayLineNot
